import { AxiosError } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export interface RequestPaymentInfoResult {
  sentCount: number;
}

const requestPaymentInfo = (athleteIds: string[]): Promise<RequestPaymentInfoResult> => {
  return client
    .post<RequestPaymentInfoResult>('athletes/request-payment-info/', { athleteIds })
    .then(res => res.data);
};

export default function useRequestPaymentInfo(): UseMutationResult<
  RequestPaymentInfoResult,
  AxiosError<ErrorMessage>,
  string[]
> {
  return useMutation(requestPaymentInfo);
}
